module.exports = __webpack_public_path__ + "img/media-img-5.3bc29925.png";